import { toDateValue } from '@pos/admin-ui';
import type { ReportRange } from '../reports/reportRange';

/** The periods the HO overview shows. */
export type Period = 'today' | '7d' | 'month' | '30d';
export const PERIODS: readonly Period[] = ['today', '7d', 'month', '30d'];

/** The business days a period covers, today included, for the store or all stores (an empty id). */
export function rangeOf(period: Period, storeId: string, today = new Date()): ReportRange {
  const start = new Date(today);
  if (period === '7d') start.setDate(today.getDate() - 6);
  if (period === '30d') start.setDate(today.getDate() - 29);
  if (period === 'month') start.setDate(1);
  return { from: toDateValue(start), to: toDateValue(today), storeId };
}
